export const getItemsByProperty = (arr,property)=>{
 try {
    return arr.map(elem=>elem[property])
 } catch (error) {
     return []
 }
}